import Modal from '~/javascripts/components/Modal';
import Swiper from 'swiper/bundle';
import { Component } from 'react';

class ProjectPhotos extends Component {
  componentDidMount = () => {
    this.smallPhotosSwiperInstance = new Swiper(this.smallPhotos, {
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: this.smallPhotosNext,
        prevEl: this.smallPhotosPrev,
      },
    });

    document.addEventListener('ModalOpened', this.onModalOpened);
  };

  componentWillUnmount = () => {
    document.removeEventListener('ModalOpened', this.onModalOpened);
  };

  onModalOpened = () => {
    this.largePhotosSwiperInstance = new Swiper(this.largePhotos, {
      controller: {
        control: this.smallPhotosSwiperInstance,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      keyboard: true,
      loop: true,
      initialSlide: this.smallPhotosSwiperInstance.activeIndex - 1,
      navigation: {
        nextEl: this.largePhotosNext,
        prevEl: this.largePhotosPrev,
      },
    });
  };

  render() {
    return (
      <div>
        <div
          className='swiper-container small-photos'
          ref={(el) => (this.smallPhotos = el)}
        >
          <div className='swiper-wrapper' onClick={() => this.modal.toggle()}>
            {this.props.photos.map((photo) => (
              <div
                className='photo swiper-slide'
                key={photo}
                style={{
                  backgroundImage: `url(https://d2otmqm66nvlp9.cloudfront.net/unsafe/resize:fill:460:300/enlarge:1/gravity:obj/objects_position:fp:0:0.2/plain/${photo})`,
                  backgroundSize: 'cover',
                }}
              />
            ))}
          </div>
          <span
            className='icon cw-icon cw-icon-angle-left'
            ref={(el) => (this.smallPhotosPrev = el)}
          />
          <span
            className='icon cw-icon cw-icon-angle-right'
            ref={(el) => (this.smallPhotosNext = el)}
          />
        </div>

        <Modal
          containerClassName='large-photos'
          modalId='project-photos'
          ref={(el) => (this.modal = el)}
        >
          <div
            className='swiper-container'
            ref={(el) => (this.largePhotos = el)}
          >
            <div className='swiper-wrapper'>
              {this.props.photos.map((photo) => (
                <div
                  className='photo swiper-slide'
                  key={photo}
                  style={{
                    backgroundImage: `url(https://d2otmqm66nvlp9.cloudfront.net/unsafe/resize:fit:1200:0/plain/${photo})`,
                  }}
                />
              ))}
            </div>
          </div>
          <span
            className='icon cw-icon cw-icon-angle-left'
            ref={(el) => (this.largePhotosPrev = el)}
          />
          <span
            className='icon cw-icon cw-icon-angle-right'
            ref={(el) => (this.largePhotosNext = el)}
          />
        </Modal>
      </div>
    );
  }
}

export default ProjectPhotos;
